var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader',{attrs:{"show-back":false}}),_c('div',{staticClass:"content-wrapper"},[_c('el-row',[_c('el-col',{staticClass:"content-left",attrs:{"span":7}},[_c('UserNavPanel')],1),_c('el-col',{staticClass:"content-right",attrs:{"span":17}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }